import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=3d9c2076&scoped=true&"
var script = {}
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=3d9c2076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9c2076",
  null
  
)

export default component.exports